import React, { useContext, useEffect } from "react";
import "./UserOnboarding.css";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/images/phx_logo_stack.svg";
import Startup from "../../assets/images/phx_startup_lowbanner.jpg";
import { Box, Typography } from "@mui/material";
import { UserPermissionsContext } from "../Dashboard/Dashboard";

export default function UserOnboarding() {
  let navigate = useNavigate();
  const userPermissions = useContext(UserPermissionsContext);

  const handlePageReload = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (userPermissions && Object.keys(userPermissions).length) {
      navigate("/dashboard/home");
    }
  }, [userPermissions]);

  return (
    <>
      <div className="Onboarding-title">
        <Typography variant="h1" color="black_solid.80">
          Thank you for visiting Phoenix.  Your account is being setup and we will be in contact soon.
        </Typography>
        <Box sx={{ display: "flex", alignItems: "end", justifyContent: "center" }}>
          <Typography variant="h3" color="black_solid.80" sx={{ marginTop: "20px" }}>
            When instructed to do so, please reload this page or click&nbsp;
          </Typography>
          <Typography variant="h3" color="primary.60" onClick={handlePageReload} sx={{ "&:hover": { cursor: "pointer" } }}>
            here.
          </Typography>
        </Box>
      </div>
      <Box className="Onboarding-logo">
        <img
          src={Logo}
          alt="Phoenix Logo"
          title="Phoenix Logo"
          width="700"
        />
      </Box>
      <Box sx={{ position: "absolute", bottom: 0, width: "100%" }}>
        <img
          src={Startup}
          alt="Phoenix Logo"
          title="Phoenix Logo"
          width="100%"
        />
      </Box>
    </>
  );
}

UserOnboarding.propTypes = {};